module.exports = __webpack_public_path__ + "assets/round-checkbox-on.69e54c8f.svg";